<div>
  <h2 class="h6" #paginationScrollTarget>{{ 'global.registration.company-select.subtitle' | translate }}</h2>
  <lib-ikp-search-bar (triggerSearch)="search($event)" dataTestPageAttribute="unternehmen-auswahl" />
  @if (this.totalCount() === 0) {
    <lib-ikp-no-content>
      <h3 class="h6 my-0">{{ 'global.errors.noCompanyResults.noResultsTitle' | translate }}</h3>
      <ul>
        <li>{{ 'global.errors.noCompanyResults.noResultsDescription-1' | translate }}</li>
        <li>{{ 'global.errors.noCompanyResults.noResultsDescription-2' | translate }}</li>
        <li>{{ 'global.errors.noCompanyResults.noResultsDescription-3' | translate }}</li>
      </ul>
    </lib-ikp-no-content>
  } @else {
    @for (item of companiesToShow(); track item.gpNr; let index = $index) {
      <lib-ikp-info-card
        [infoCardType]="InfoCardType.ACCORDION"
        [title]="item.name"
        subtitle="{{ 'global.registration.company-select.entry.subtitle' | translate: { customerNr: item.gpNr } }}"
        [isCollapsed]="index !== 0"
        [isCheckbox]="true"
        [isChecked]="isItemChecked(item.gpNr)"
        (actionClicked)="checkboxClicked(item.gpNr)"
        [index]="index"
        [attr.data-test]="'companySelect-infoCard-' + index"
        dataTestPrefix="companySelect"
      >
        <div class="row">
          <div class="col-12 col-xl-4">
            <lib-ikp-info-input-read-only
              id="address"
              label="{{ 'global.address' | translate }}"
              [value]="getFormattedAddress(item.address)"
            />
          </div>
          <div class="col-12 col-xl-4">
            <lib-ikp-info-input-read-only id="business-partner-id" label="{{ 'global.customerNr' | translate }}" [value]="item.gpNr" />
          </div>
          @if (false) {
            <div class="col-12 col-xl-4 d-flex flex-column" style="display: none">
              <a class="link p-2comma5" data-test="unternehmenAuswahl-anchor-vknrDetailAnsicht">
                {{ 'global.registration.company-select.entry.cta' | translate }}
              </a>
            </div>
          }
          <div class="col-12 col-xl-4">
            <lib-ikp-info-input-read-only
              id="uid"
              label="{{ 'global.registration.company-select.entry.uid' | translate }}"
              [value]="item.uid"
            />
          </div>
          <div class="col-12 col-xl-4">
            <!-- data not available, not within the scope of mvp -->
            <lib-ikp-info-input-read-only
              id="industry"
              label="{{ 'global.registration.company-select.entry.industry' | translate }}"
              [value]="item.branche"
              style="display: none"
            />
          </div>
          <div class="col-12 col-xl-4">
            <!-- data not available, not within the scope of mvp -->
            <lib-ikp-info-input-read-only
              id="employeecount'"
              label="{{ 'global.registration.company-select.entry.size' | translate }}"
              [value]="item.mitarbeiterAnzahl"
              style="display: none"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-xl-4">
            <lib-ikp-info-input-read-only
              id="email"
              label="{{ 'global.registration.company-select.entry.email' | translate }}"
              [value]="item.email"
            />
          </div>
        </div>
      </lib-ikp-info-card>
    }
    <lib-ikp-pagination
      [currentPage]="page()"
      [allPagesNumber]="totalPages()"
      [paginatedElement]="paginationScrollTarget"
      [dataUpdate$]="paginationUpdate$"
      (changePage)="onPageChange($event)"
    />
  }
</div>
